export const COMPANY_NO_INTEGRATION = 0;
export const COMPANY_LINX_INTEGRATION = 1;

export class CompanySettings {
  integrationName: string;
  integration: number;
  allowCreditRewards: boolean;
}
